import {getIdToken} from "../auth/authProviders";
import {recordOwnDecision} from "../consent/ownDecisions";
import type {TermsAcceptancePayload} from "./termsAcceptanceReplay";

/**
 * The authenticated terms-acceptance record (api#744), now `RecordOwnDecision` for the `TERMS` purpose of the
 * platform's consent service (kitecorp/transferify-ui#3953).
 *
 * Auth rides the shared Connect transport's bearer interceptor (`api/connectTransport`), but unlike ordinary
 * requests this legal record first verifies the cached account against restored Firebase auth, then binds
 * the call to that exact uid. A mismatch therefore rejects before ownership moves; a later account
 * change rejects the request so the replay coordinator can return a newly moved claim to the unclaimed
 * slot with the account that clicked, if any (api#780).
 *
 * The record is idempotent per terms version: the first acceptance on file is kept, so replaying an
 * already-recorded version is a successful no-op rather than a moved timestamp. The instant of the click is not sent:
 * the platform stamps its own clock, and the ui keeps the instant only to key its replay.
 */
export async function verifyTermsAcceptanceAccount(accountId: string): Promise<void> {
	await getIdToken(false, accountId);
}

export async function submitTermsAcceptance(
	accountId: string,
	payload: TermsAcceptancePayload,
): Promise<void> {
	await recordOwnDecision("TERMS", {granted: true, version: payload.version}, {expectedFirebaseUid: accountId});
}
